var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-banner"},[(_vm.bannerUrl)?_c('img',{attrs:{"src":_vm._f("filterPicture")(_vm.bannerUrl)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }